/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/network';
import '../common/common';
import './verification';
import './auth';
import './balance';
import './recorded';
import './bank';
import './async_transaction';
import './sync';
import '../../privacyvault/annotations';
import '../../risk-metadata-protos/risk_metadata';
import '../common/metadata';
import './cross_method_refund';
import './authentication';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "RecordType": {
                "values": {
                  "DEFAULT_RECORD_TYPE_DO_NOT_USE": 0,
                  "CARD_TRANSACTION": 1,
                  "BALANCE_TRANSACTION": 2,
                  "CARD_VERIFICATION": 3,
                  "RECORDED_TRANSACTION": 4,
                  "BANK_TRANSACTION": 5,
                  "ASYNC_TRANSACTION": 7
                }
              },
              "PaymentTag": {
                "values": {
                  "DEFAULT_PAYMENT_TAG": 0,
                  "TIVO_ON_US": 1,
                  "TIVO_REPLAY": 2
                }
              },
              "PaymentSystem": {
                "values": {
                  "DEFAULT_PAYMENT_SYSTEM": 0,
                  "SQUARE_WEB": 1,
                  "EDJE": 2,
                  "ESPERANTO": 3
                }
              },
              "PaymentSource": {
                "fields": {
                  "paymentSystem": {
                    "type": "squareup.esperanto.model.PaymentSystem",
                    "id": 1,
                    "rule": "optional"
                  },
                  "datacenter": {
                    "type": "squareup.common.network.Datacenter",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PaymentRecord": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "clientPaymentKey": {
                    "type": "squareup.esperanto.common.ClientPaymentKey",
                    "id": 2,
                    "rule": "optional"
                  },
                  "parentPaymentId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "paymentType": {
                    "type": "squareup.esperanto.model.RecordType",
                    "id": 5,
                    "rule": "optional"
                  },
                  "cardVerification": {
                    "type": "squareup.esperanto.model.CardVerification",
                    "id": 19,
                    "rule": "optional"
                  },
                  "cardTransaction": {
                    "type": "squareup.esperanto.model.CardTransaction",
                    "id": 6,
                    "rule": "optional"
                  },
                  "balanceTransaction": {
                    "type": "squareup.esperanto.model.BalanceTransaction",
                    "id": 16,
                    "rule": "optional"
                  },
                  "recordedTransaction": {
                    "type": "squareup.esperanto.model.RecordedTransaction",
                    "id": 22,
                    "rule": "optional"
                  },
                  "bankTransaction": {
                    "type": "squareup.esperanto.model.BankTransaction",
                    "id": 23,
                    "rule": "optional"
                  },
                  "asyncTransaction": {
                    "type": "squareup.esperanto.model.AsyncTransaction",
                    "id": 27,
                    "rule": "optional"
                  },
                  "log": {
                    "type": "squareup.esperanto.model.LogEntry",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "tags": {
                    "type": "squareup.esperanto.model.PaymentTag",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "transactionGroupId": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "billInfo": {
                    "type": "squareup.esperanto.common.BillInfo",
                    "id": 10,
                    "rule": "optional"
                  },
                  "source": {
                    "type": "squareup.esperanto.model.PaymentSource",
                    "id": 11,
                    "rule": "optional"
                  },
                  "moneyTransferDetails": {
                    "type": "squareup.esperanto.common.MoneyTransferDetails",
                    "id": 12,
                    "rule": "optional"
                  },
                  "vaultedData": {
                    "type": "squareup.privacyvault.VaultedData",
                    "id": 13,
                    "rule": "optional"
                  },
                  "riskMetadata": {
                    "type": "squareup.risk.RiskMetadata",
                    "id": 14,
                    "rule": "optional"
                  },
                  "paymentMetadata": {
                    "type": "squareup.esperanto.common.PaymentMetadata",
                    "id": 15,
                    "rule": "optional"
                  },
                  "refundMetadata": {
                    "type": "squareup.esperanto.common.RefundMetadata",
                    "id": 17,
                    "rule": "repeated"
                  },
                  "crossMethodRefunds": {
                    "type": "squareup.esperanto.model.CrossMethodRefund",
                    "id": 28,
                    "rule": "repeated"
                  },
                  "feeEvents": {
                    "type": "squareup.esperanto.common.ProcessingFeeEvent",
                    "id": 18,
                    "rule": "repeated"
                  },
                  "appFeeEvents": {
                    "type": "squareup.esperanto.common.AppFeeEvent",
                    "id": 21,
                    "rule": "repeated"
                  },
                  "revenueAssociationTags": {
                    "type": "string",
                    "id": 20,
                    "rule": "repeated"
                  },
                  "authenticationResult": {
                    "type": "squareup.esperanto.model.AuthenticationResult",
                    "id": 24,
                    "rule": "optional"
                  },
                  "internalAdminMetadata": {
                    "type": "squareup.esperanto.common.InternalAdminMetadata",
                    "id": 29,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RecordType && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.PaymentTag && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.PaymentSystem && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.PaymentSource && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.PaymentRecord) {
  $root.addJSON(jsonData);
}

/**
 * Record type. Used to indicate what record field is set.
 *
 * SOURCE RecordType @ squareup/esperanto/model/payments.proto at 27:1
 */
export const RecordType = $root.lookupEnum('squareup.esperanto.model.RecordType').values;
/**
 * Payment tag. Used to indicate special payment record.
 *
 * SOURCE PaymentTag @ squareup/esperanto/model/payments.proto at 42:1
 */
export const PaymentTag = $root.lookupEnum('squareup.esperanto.model.PaymentTag').values;
/**
 * Indicates the software system in which this payment was originally mastered.
 *
 * SOURCE PaymentSystem @ squareup/esperanto/model/payments.proto at 60:1
 */
export const PaymentSystem = $root.lookupEnum('squareup.esperanto.model.PaymentSystem').values;
/**
 * Indicates the system in which this payment was originally mastered.
 *
 * SOURCE PaymentSource @ squareup/esperanto/model/payments.proto at 70:1
 */
export const PaymentSource = $root.lookupType('squareup.esperanto.model.PaymentSource');
fixType(PaymentSource);
Builder.createAndAttachToType(PaymentSource);
/**
 * Describes a payment.
 *
 * SOURCE PaymentRecord @ squareup/esperanto/model/payments.proto at 78:1
 */
export const PaymentRecord = $root.lookupType('squareup.esperanto.model.PaymentRecord');
fixType(PaymentRecord, {
  paymentId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PaymentRecord);